var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { SelectableNavigationItem } from '../../../model/selectable-navigation-item';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { PageNames } from '../../../shared/page-names.enum';
import { EmitterConstants } from '../../../shared/emitter-constants';
import { Emitter } from '../../../shared/utils/emitter/emitter';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { KeyDirections } from '../../../shared/key-directions.enum';
var InputTrialCodeComponent = /** @class */ (function (_super) {
    __extends(InputTrialCodeComponent, _super);
    function InputTrialCodeComponent(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.emitOnEnterPressed = new EventEmitter();
        _this.navigationService.registerNavigation(_this, PageNames.TRIAL_CODE_MODAL);
        return _this;
    }
    InputTrialCodeComponent.prototype.ngOnInit = function () {
        this.inputForm = new FormGroup({
            code: new FormControl([''], Validators.required)
        }, {}, null);
        this.detectInputValueChanges();
    };
    InputTrialCodeComponent.prototype.detectInputValueChanges = function () {
        var _this = this;
        this.inputForm.valueChanges.subscribe(function (value) {
            _this.inputForm.setValue({ code: _this.handleInputWhitespace(value.code) }, { emitEvent: false });
            Emitter.of(EmitterConstants.INPUT_TRIAL_CODE).emit({ code: _this.inputForm.value.code.toString().replace(/\D/g, '') });
        });
    };
    InputTrialCodeComponent.prototype.onBack = function () {
        document.activeElement.blur();
        Emitter.of(EmitterConstants.BACK_PRESSED).emit(PageNames.TRIAL_CODE_MODAL);
    };
    InputTrialCodeComponent.prototype.onEnter = function () {
        this.emitOnEnterPressed.emit({
            value: true
        });
    };
    InputTrialCodeComponent.prototype.activate = function (active) {
        var _this = this;
        this.active = active;
        if (this.active) {
            setTimeout(function () {
                _this.inputCode.nativeElement.focus();
            }, 100);
        }
    };
    InputTrialCodeComponent.prototype.handleInputWhitespace = function (code) {
        return code.toString()
            .replace(/\D/g, '')
            .replace(/(.{4})/g, '$1 ')
            .trim();
    };
    InputTrialCodeComponent.prototype.containsValue = function () {
        return this.inputForm.value.code.toString() !== '';
    };
    InputTrialCodeComponent.prototype.handleEvent = function ($event) {
        if ($event.keyCode === KeyDirections.ARROW_LEFT && this.inputForm.value.code) {
            this.removeTheLastCharacter();
        }
    };
    InputTrialCodeComponent.prototype.removeTheLastCharacter = function () {
        this.inputForm.setValue({ code: this.inputForm.value.code.toString().slice(0, -1) }, { emitEvent: true });
    };
    return InputTrialCodeComponent;
}(SelectableNavigationItem));
export { InputTrialCodeComponent };
